import { FC, useEffect, useRef, useState } from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../Components/ui/card";
import { Button } from "../../Components/ui/button";
import { useSelector } from "react-redux";
import { RootState } from "../../State/store";
import axios from "axios";
import { useToast } from "../../Components/ui/use-toast";
import { Toaster } from "../../Components/ui/toaster";
import { Input } from "src/Components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../Components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/Components/ui/dialog";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../Components/ui/select";
import { CaretSortIcon, DotsHorizontalIcon } from "@radix-ui/react-icons";
import { table } from "console";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../Components/ui/dropdown-menu";
import CircularProgress from "@mui/material/CircularProgress";
import { Badge } from "../../Components/ui/badge";
import { RadioGroup, RadioGroupItem } from "../../Components/ui/radio-group";

import { Label } from "../../Components/ui/label";
import { channel } from "diagnostics_channel";
import { useLocation } from "react-router-dom";
import { access } from "fs";

import {
  CheckCircle,
  Clock,
  FileIcon,
  HelpCircle,
  Loader2,
  XCircle,
} from "lucide-react";
import { ChevronDown } from "lucide-react";
import { RefreshCw } from "lucide-react";
import { Plus } from "lucide-react";
import { Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../Components/ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../Components/ui/tooltip";

declare const FB: any; // Declare FB as a global object

export interface ChannelConfig {
  channel_config_id: number;
  channel_id: number;
  channel_config_name: string;
  channel_status: string;
  partner_type: string;
  partner_id: number;
  channelserver_url: string;
  channelserver_app_status: string;
  channelserver_app_remarks: string;
  created_time: string;
  last_updated_time: string;
  channel_config: string;
  api_type: string;
  wm_template_id?: number; // ✅ ADD THIS
  template_name?: string; // ✅ ADD THIS
}

export interface ChannelServerConfig {
  channel_server_ip: string;
  channelserver_app_port: string;
  channelserver_status: string;
  channel_id: number;
}

// Interface for Owner Business Info
export interface OwnerBusinessInfo {
  name: string;
  id: string;
}

// Interface for WhatsApp Owner Details Response
export interface WhatsappOwnerDetailsResponse {
  id: string;
  name: string;
  ownerBusinessInfo: OwnerBusinessInfo;
}

export interface WABA {
  wabaId: string;
  phoneId: string;
  Id: number;
}

type ChannelUrlItem = {
  url: string;
  channelserver_id: number;
  channelserver_app_id: number;
  channelserver_name: string;
};

const Whatsapp: FC = () => {
  const [wabaId, setWabaId] = useState("");
  const [phoneId, setPhoneId] = useState("");
  const [Id, setId] = useState(0);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isApiExecuting, setIsApiExecuting] = useState(false);
  const [isConnectOpen, setIsConnectOpen] = useState(false);
  const [isCustomDialogOpen, setIsCustomDialogOpen] = useState(false);
  const [isConnectDialogOpen, setIsConnectDialogOpen] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState<string>("");
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [selectedChannelServerId, setSelectedChannelServerId] =
    useState<number>(0);
  const [selectedChannelConfigId, setSelectedChannelConfigId] =
    useState<number>(0);
  const [selectedChannelServerAppId, setSelectedChannelServerAppId] =
    useState<number>(0);
  const [channelUrls, setChannelUrls] = useState<ChannelUrlItem[]>([]);
  const [currentChannelId, setCurrentChannelId] = useState<number | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const [selectedOption, setSelectedOption] = useState("meta");
  const [customConfigText, setCustomConfigText] = useState<string>("");
  const [currentChannelConfigId, setCurrentChannelConfigId] =
    useState<number>(0);

  const location = useLocation();
  const channelId = location.state.channelId;
  const channelName = location.state.channelName;
  const partnerId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const role_id = useSelector(
    (state: RootState) => state.authentication.role_id,
  );

  console.log("Role Id :-------------" + role_id);

  const isAdmin = useSelector(
    (state: RootState) => state.authentication.isAdmin,
  );

  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );

  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  const [welcomeTemplateList, setWelcomeTemplateList] = useState<any[]>([]);
  debugger;
  const [isWelcomeTemplateDialogOpen, setIsWelcomeTemplateDialogOpen] =
    useState(false);
  const [selectedExtTemplateId, setSelectedExtTemplateId] = useState<
    string | undefined
  >(undefined);
  console.log("selectedtemplatesexttemplated", selectedExtTemplateId);

  console.log("isAdmin :-------------" + isAdmin);
  // const partnerId = 1701;
  const OperatorUrl = useSelector(
    (state: RootState) => state.authentication.operatorUrl,
  );

  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );

  const [openMenuId, setOpenMenuId] = useState<number | null>(null);

  const [configs, setConfigs] = useState<ChannelConfig[]>([]);
  const [signInSts, setSignInSts] = useState("");
  const [loading, setLoading] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [tableData, setTableData] = useState<ChannelConfig[]>([]);
  const [connectStatus, setConnectStatus] = useState(false);
  const [whatsappOwnerDetails, setWhatsappOwnerDetails] =
    useState<WhatsappOwnerDetailsResponse | null>(null);
  const toast = useToast();
  const whatsappUrl = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );
  const emailId = useSelector(
    (state: RootState) => state.authentication.userEmail,
  );
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );

  const [whatsappTemplateSearchQuery, setWhatsappTemplateSearchQuery] =
    useState("");

  // const ImpAccountId=useSelector(
  //   (state:RootState) => state.admin.Impersonator?.ImpersonationState
  // );

  const [isUpdate, setIsUpdate] = useState(false);
  // const workspaceId = 1701;

  const [channelConfigName, setChannelConfigName] = useState<string>("");
  const [channelConfigId, setChannelConfigId] = useState<number>(0);
  console.log("channelConfigIdforapi", channelConfigId);
  const [channelConfigStatus, setChannelConfigStatus] = useState<string>("");
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");

  const workspace = useSelector(
    (state: RootState) => state.authentication.workspaceName,
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Calculate pagination values
  //const totalCount = tableData.length;
  const totalPages = Math.ceil(totalCount / rowsPerPage);
  // const paginatedData = tableData.slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage,
  // );
  console.log("tableData:", tableData);
  console.log("tableData length:", tableData.length);
  // console.log("paginatedData:", paginatedData);
  const [openMenuRowId, setOpenMenuRowId] = useState<number | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isDeliveryWindowDialogOpen, setIsDeliveryWindowDialogOpen] =
    useState(false);
  const [ttlValue, setTtlValue] = useState<string>("");
  const [unit, setUnit] = useState<"hours" | "days">("hours");
  const [openRow, setOpenRow] = useState<number | null>(null);
  const configId = process.env.REACT_APP_WHATSAPP_SIGNUP_CONFIG_ID;

  //console.log ("configId : ---------->",configId);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpenMenuId(null); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const [wabaDetails,setwabaDetails] = useState<{ wabaId: string;phoneId: string;Id:number;}>({wabaId:"",phoneId:"",Id:0});
  useEffect(() => {
    setTimeout(() => {
      //checkTokenValidity();
    }, 500);
  }, [connectStatus]);

  useEffect(() => {
    debugger;
    if (signInSts !== "signup" && signInSts !== "addPhoneNumber") return;

    const handleMessage = (event: MessageEvent) => {
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }

      try {
        const data = JSON.parse(event.data);

        if (data.type === "WA_EMBEDDED_SIGNUP" && data.event === "FINISH") {
          const { phone_number_id, waba_id } = data.data;

          setWabaId(waba_id);
          setPhoneId(phone_number_id);
          console.log(`waba_id: ${waba_id}, phone_id: ${phone_number_id}`);

          // if (signInSts === "signup") {
          //   InsertWabaDetails(waba_id, phone_number_id);
          // } else if (signInSts === "addPhoneNumber") {
          //   registerNumber(phone_number_id);
          // }
        }
      } catch {
        console.log("Non-JSON Response received: ", event.data);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [signInSts]);

  const afterLogin = async () => {
    await subscribeToWebhook();
    await checkTokenValidity();
  };

  useEffect(() => {
    if (phoneId && accessToken) {
      registerNumberWithMeta(phoneId, accessToken, "123456");
    }
  }, [phoneId, accessToken]);

  const checkPhoneStatus = async (phoneId: string, accessToken: string) => {
    try {
      const res = await axios.get(`${OperatorUrl}/CheckPhoneStatus`, {
        params: {
          phoneId,
          accessToken,
        },
      });

      const status = res.data?.status;
      console.log(`📊 Phone status: ${status}`);
      return status;
    } catch (error: any) {
      console.error(
        "❌ Status check failed:",
        error.response?.data || error.message,
      );
      throw error;
    }
  };

  // const updateWelcomeTemplate = async (extTemplateId: number, channelConfigId: number) => {
  //   try {
  //     setIsUpdating(true);
  //     const response = await axios.put(
  //       `${OperatorUrl}/UpdateTemplateId`,
  //       {
  //         templateId: extTemplateId,
  //         channelConfigId: channelConfigId
  //       }
  //     );

  //     if (response.data.status === "Success") {
  //       toast.toast({
  //         title: "Success",
  //         description: "Welcome template updated successfully"
  //       });
  //     } else {
  //       toast.toast({
  //         title: "Error",
  //         description: response.data.message || "Failed to update welcome template",
  //         variant: "destructive"
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error updating welcome template:", error);
  //     toast.toast({
  //       title: "Error",
  //       description: "Failed to update welcome template",
  //       variant: "destructive"
  //     });
  //   } finally {
  //     setIsUpdating(false);
  //   }
  // };

  // Facebook Login Callback
  // const fbLoginCallback = (response: any) => {
  //   if (response.status === "connected") {
  //     console.log("login callback initiated");
  //     console.log("login callback ended!");
  //   } else {
  //     console.error("User not logged in:", response);
  //   }
  // };

  // --- Facebook login callback ---
  const updateWelcomeTemplate = async (
    extTemplateId: number,
    channelConfigId: number,
  ) => {
    try {
      setIsUpdating(true);
      const response = await axios.put(`${OperatorUrl}/UpdateTemplateId`, {
        templateId: extTemplateId,
        channelConfigId: channelConfigId,
      });

      // Check if response has data (success case)
      if (response.data) {
        toast.toast({
          title: "Success",
          description: "Template Linked successfully",
        });
        setIsWelcomeTemplateDialogOpen(false);
        fetchChannelConfigs(partnerId);
      }
    } catch (error: any) {
      toast.toast({
        title: "Error",
        description: error.response?.data?.message || "Failed to link template",
        variant: "destructive",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const fbLoginCallback = (response: any) => {
    // Just call your async logic without making fbLoginCallback itself async
    handleFbLoginResponse(response);
  };

  const handleTTLChange = (value: string) => {
    setTtlValue(value);
  };

  const handleTTLBlur = () => {
    const num = Number(ttlValue);
    if (!ttlValue) return;

    if (unit === "hours") {
      if (num < 12) setTtlValue("12");
      if (num > 720) setTtlValue("720");
    }

    if (unit === "days") {
      if (num < 1) setTtlValue("1");
      if (num > 30) setTtlValue("30");
    }
  };

  const getTTLHours = async (channelConfigId: number) => {
    try {
      const response = await axios.get(`${OperatorUrl}/GetTTLHours`, {
        params: { ChannelConfigId: channelConfigId, ChannelId: channelId },
      });

      debugger;
      if (response.data?.status === "Success") {
        const ttlHours = response.data.msg_validity_hours;

        if (ttlHours > 24 && ttlHours % 24 === 0) {
          setUnit("days");
          setTtlValue(String(ttlHours / 24));
        } else {
          setUnit("hours");
          setTtlValue(String(ttlHours));
        }
      }
    } catch (error) {
      console.error("Failed to fetch TTL:", error);
    }
  };

  const updateDeliveryWindow = async (
    value: number,
    unit: string,
    channelConfigId: number,
  ) => {
    try {
      setIsUpdating(true);

      // Convert to hours for backend
      let MessageValidityHours = value;
      if (unit === "days") MessageValidityHours = value * 24;
      // if (unit === "weeks") ttlInHours = value * 24 * 7;

      const payload = {
        ChannelConfigId: channelConfigId,
        ChannelId: channelId,
        MessageValidityHours: MessageValidityHours,
        ChannelType: channelName,
        partnerId: partnerId,
        accountId: accountId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      const response = await axios.put(
        `${OperatorUrl}/UpdateTTLHours`,
        payload,
      );

      if (response.data) {
        toast.toast({
          title: "Success",
          description: "Message Validity Period updated successfully",
        });
        fetchChannelConfigs(partnerId);
      }
    } catch (error: any) {
      toast.toast({
        title: "Error",
        description:
          error.response?.data?.message ||
          "Failed to update message validity period",
        variant: "destructive",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  // Move async logic here
  const handleFbLoginResponse = async (response: any) => {
    setLoading(true);
    try {
      if (response.status === "connected" && response.authResponse?.code) {
        const code = response.authResponse.code;
        console.log("🔑 Code received from Facebook:", code);

        // 1️⃣ Send code to backend to exchange for access token

        const res = await axios.post(`${OperatorUrl}/ExchangeToken`, { code });
        const token = res.data?.access_token;

        if (token) {
          setLoading(false);
          console.log("✅ Access Token received:", token);
          setAccessToken(token);
        } else {
          setLoading(false);
          console.warn("⚠️ No access_token in backend response");
        }
      }
    } catch (error: any) {
      setLoading(false);
      console.error(
        "🚨 Error exchanging token:",
        error.response?.data || error.message,
      );
    } finally {
      setLoading(false); // Always runs (success or failure)
    }
  };

  // --- 3️⃣ Register phone number with Meta using client’s access token ---
  const registerNumberWithMeta = async (
    phoneId: string,
    accessToken: string,
    pin: string,
  ) => {
    setLoading(true); // Start loading spinner

    try {
      console.log("Checking phone number status...");

      const result = await axios.get(`${OperatorUrl}/CheckPhoneStatus`, {
        params: { phoneId, accessToken },
      });

      const status = result.data?.status;
      console.log(`Phone status: ${status}`);

      if (status === "PENDING") {
        console.log("Status is PENDING - registering...");

        const res = await axios.post(`${OperatorUrl}/RegisterPhoneNumber`, {
          phoneId,
          accessToken,
          pin,
        });

        console.log("Registration Success:", res.data);

        if (wabaId) {
          await InsertWabaDetails(wabaId, phoneId);
        }

        return res.data;
      } else {
        // Handles CONNECTED, FAILED, or any other statuses
        console.log(`Phone status is ${status} - skipping registration`);

        if (wabaId) {
          await InsertWabaDetails(wabaId, phoneId);
        }

        return { status };
      }
    } catch (error: any) {
      console.error(
        "Registration failed:",
        error.response?.data || error.message,
      );

      toast.toast({
        title: "Error",
        description:
          "Failed to submit configuration. Please check and try again",
        variant: "destructive",
      });

      throw error;
    } finally {
      setLoading(false); // Always runs (success or failure)
    }
  };

  // Launch WhatsApp Signup
  const launchWhatsAppSignup = (mode: string) => {
    if (mode === "connect") {
      FB.login(fbLoginCallback, {
        config_id: configId,
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: "",
          sessionInfoVersion: "2",
        },
      });
      setSignInSts("signup");
      return true;
    } else if (mode === "addPhoneNumber") {
      FB.login(fbLoginCallback, {
        config_id: configId,
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: "",
          sessionInfoVersion: "2",
        },
      });
      setSignInSts("addPhoneNumber");
      return true;
    }
  };

  const subscribeToWebhook = async () => {
    try {
      const response = await axios.post(
        `${whatsappUrl}/SubscribeToWebhook?workspaceId=${workspaceId}`,
      );
      if (response.data.status === "Success") {
        console.log("Webhook Subscribed Successfully");
      } else {
        console.error("Webhook Subscription failed");
      }
    } catch (error) {
      console.log("An error occurred during webhook subscription: ", error);
    }
  };

  const unsubscribeFromWebhook = async () => {
    try {
      const response = await axios.delete(
        `${whatsappUrl}/UnsubscribeFromWebhook?workspaceId=${workspaceId}`,
      );
      if (response.data.status === "Success") {
        console.log("Webhook Unsubscribed Successfully");
      } else {
        console.error("Webhook Unsubscription failed");
      }
    } catch (error) {
      console.log("An error occurred during webhook unsubscription: ", error);
    }
  };

  const disconnectWhatsappAccount = async () => {
    try {
      setIsApiExecuting(true);
      const response = await axios.delete(
        `${whatsappUrl}/DisconnectWhatsappAccount?WorkspaceId=${workspaceId}`,
      );
      if (response.data.status === "Success") {
        setIsAlertOpen(false);
        const Close = () => {};
        toast.toast({
          title: "Success",
          description: "Disconnected Whatsapp Account Successfully",
        });
        checkTokenValidity();
        Close();
      } else {
        toast.toast({
          title: "Error",
          description: "Error in Disconnecting WABA",
        });
      }
    } catch (error) {
      toast.toast({
        title: "Error",
        description: "Disconnect API Error",
      });
    } finally {
      setIsApiExecuting(false);
      setIsAlertOpen(false);
    }
  };

  const checkTokenValidity = async () => {
    try {
      setLoading(true);
      // Check token validity
      const response = await axios.get(
        `${whatsappUrl}/IsWhatsappTokenValid?workspaceId=${workspaceId}`,
      );
      console.log("status: " + response.data.status);
      if (response.data.status === "Success") {
        setIsTokenValid(response.data.isValid);
        setConnectStatus(true);
        console.log("token validity: ", isTokenValid);
        // toast.toast({
        //   title: "Success",
        //   description: "Token is valid",
        // });
        // Fetch table data
        const TableData = await axios.get(
          `${whatsappUrl}/GetWhatsappPhoneNumbers?workspaceId=${workspaceId}`,
        );
        if (TableData.data.status === "Success") {
          //setTableData(TableData.data.data);
          console.log("table data: " + tableData);
        } else {
          toast.toast({
            title: "Error",
            description: "No phone numbers found",
          });
        }

        // Fetch WhatsApp owner details
        const whatsappOwnerResponse = await axios.get(
          `${whatsappUrl}/GetWhatsappOwnerDetails?workspaceId=${workspaceId}`,
        );
        if (whatsappOwnerResponse.data.status === "Success") {
          setWhatsappOwnerDetails(whatsappOwnerResponse.data.data); // Single object
          console.log(
            "whatsapp owner details: ",
            whatsappOwnerResponse.data.data,
          );
        } else {
          toast.toast({
            title: "Error",
            description: "No details found",
          });
        }
      } else {
        setIsTokenValid(response.data.isValid);
        setConnectStatus(false);
        console.log("token validity: ", isTokenValid);
      }
    } catch (error) {
      console.error("Error checking token validity:", error);
      toast.toast({
        title: "Error",
        description: "An error occurred",
      });
    }
    setLoading(false);
  };

  const handleConnect = () => {
    console.log("Connecting with:", selectedOption);
    setIsApiExecuting(true);
    // Your connection logic here...
    setTimeout(() => {
      setIsApiExecuting(false);
      setIsConnectOpen(false);
    }, 2000);
  };

  const registerNumber = async (phoneId: string) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${whatsappUrl}/RegisterWhatsappNumber?workspaceId=${workspaceId}&phoneId=${phoneId}`,
      );
      if (response.data.status == "Success") {
        toast.toast({
          title: "Success",
          description: "Phone Number Registered Successfully",
        });
      } else {
        toast.toast({
          title: "Error",
          description: "Error Registering phone number",
        });
      }
    } catch (error) {
      toast.toast({
        title: "Error",
        description: "Api Error in registering phone number",
      });
    }
    setLoading(false);
  };

  const deRegisterNumber = async (phoneId: string) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${whatsappUrl}/DeRegisterWhatsappNumber?workspaceId=${workspaceId}&phoneId=${phoneId}`,
      );
      if (response.data.status == "Success") {
        toast.toast({
          title: "Success",
          description: "Phone Number DeRegistered Successfully",
        });
      } else {
        toast.toast({
          title: "Error",
          description: "Error DeRegistering phone number",
        });
      }
    } catch (error) {
      toast.toast({
        title: "Error",
        description: "Api Error in deRegistering phone number",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (wabaId !== "" && phoneId !== "" && Id != 0) {
      console.log("phId: " + phoneId + " wabaID: " + wabaId + "Id: " + Id);
    }
  }, [wabaId, phoneId]);

  const InsertWabaDetails = async (wabaid: string, phoneid: string) => {
    try {
      const wrapped = {
        config: {
          app_id: "",
          waba_id: wabaid,
          phone_id: phoneid,
          access_token: "",
        },
        api_type: selectedOption,
        api_vendor: workspace,
        channel_id: channelId,
        channel_type: channelName,
        max_validity_hours: 24,
      };

      // 1. Get unique config name from backend
      const { data } = await axios.get(
        `${OperatorUrl}/GenerateChannelConfigName`,
        {
          params: {
            workspace: workspace,
            configType: selectedOption,
          },
        },
      );

      const channelConfigName: string = data.channelConfigName;

      // 2. Prepare payload for insert API
      const payload = {
        ChannelId: Number(channelId),
        ChannelConfigName: channelConfigName,
        ChannelConfig: JSON.stringify(wrapped),
        ChannelStatus: "active", // or dynamically get from UI if needed
        PartnerId: workspaceId,
        AccountId: accountId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        PhoneId: phoneId,
      };

      // 3. Insert the config via backend API
      const insertResponse = await axios.post(
        `${OperatorUrl}/InsertChannelConfig`,
        payload,
      );

      if (insertResponse.status === 200) {
        toast.toast({
          title: "Success",
          description: "Channel config inserted successfully.",
        });

        console.log("✅ Insert response:", insertResponse.data);

        setIsConnectOpen(false);

        setIsCustomDialogOpen(false);

        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Insert Failed",
          description: "Unexpected response from server.",
        });
      }
    } catch (error: any) {
      console.error("❌ Submission error:", error);
      toast.toast({
        title: "Error",
        description:
          error?.response?.data?.error ||
          "Failed to submit configuration. Please check and try again.",
      });
    } finally {
    }
  };

  //  const InsertWabaDetails = async (wabaid: string, phoneid: string) => {

  //   let payload={}
  //   let auditStatus="Success"

  //     try {
  //       const wrapped = {
  //         config: {
  //           app_id: "",
  //           waba_id: wabaid,
  //           phone_id: phoneid,
  //           access_token: "",
  //         },
  //         api_type: selectedOption,
  //         api_vendor: workspace,
  //         channel_id: channelId,
  //         channel_type: channelName,
  //       };

  //       // 1. Get unique config name from backend
  //       const { data } = await axios.get(
  //         `${OperatorUrl}/GenerateChannelConfigName`,
  //         {
  //           params: {
  //             workspace: workspace,
  //             configType: selectedOption,
  //           },
  //         }
  //       );

  //       const channelConfigName: string = data.channelConfigName;

  //       // 2. Prepare payload for insert API
  //       payload = {
  //         ChannelId: Number(channelId),
  //         ChannelConfigName: channelConfigName,
  //         ChannelConfig: JSON.stringify(wrapped),
  //         ChannelStatus: "active", // or dynamically get from UI if needed
  //         PartnerId: workspaceId,
  //       };

  //       // 3. Insert the config via backend API
  //       const insertResponse = await axios.post(
  //         `${OperatorUrl}/InsertChannelConfig`,
  //         payload
  //       );

  //       if (insertResponse.status === 200) {
  //         toast.toast({
  //           title: "Success",
  //           description: "Channel config inserted successfully.",
  //         });

  //         console.log("✅ Insert response:", insertResponse.data);

  //         setIsConnectOpen(false);

  //         setIsCustomDialogOpen(false);

  //         fetchChannelConfigs(partnerId);
  //       } else {
  //         toast.toast({
  //           title: "Insert Failed",
  //           description: "Unexpected response from server.",
  //         });
  //       }
  //     } catch (error: any) {
  //       console.error("❌ Submission error:", error);
  //       toast.toast({
  //         title: "Error",
  //         description:
  //           error?.response?.data?.error ||
  //           "Failed to submit configuration. Please check and try again.",
  //       });
  //     }
  //     finally{
  //       try {
  //         axios.post(`${apiUrlAdvAcc}/InsertOverAllAuditHistory`, {
  //           userAccountId: accountId ?? null,              // if you have it in state/context
  //           campaignId: null,                              // not applicable here
  //           advertiserWorkspaceId: workspaceId ?? null,    // include if relevant, else null
  //           action: "Update Profile Name",
  //           actionPage: "Profile Settings",
  //           status: auditStatus,
  //           // beforeData,                                    // valid JSON string
  //           afterData:payload,                                     // valid JSON string (now accurate)
  //           ipAddress: "",                                 // server will treat empty as NULL
  //           comments: "Profile Name Updated "
  //         });
  //       } catch (e) {
  //         // Swallow audit errors to avoid interrupting UX
  //         console.warn("Audit insert failed", e);
  //       }
  //     }
  //   };

  const handleMenuToggle = (rowId: number) => {
    setOpenMenuRowId(openMenuRowId === rowId ? null : rowId);
  };

  const openDeleteDialog = (id: number, name: string) => {
    setChannelConfigId(id);
    setChannelConfigName(name);
    setIsDeleteDialogOpen(true);
  };

  const handleDelete = async () => {
    debugger;
    const details = await getChannelConfigById(channelConfigId); // now returns data
    const parsedConfig = JSON.parse(details.channel_config);

    const wrapped = {
      config: { ...parsedConfig.config },
      api_type: selectedOption,
      api_vendor: workspace,
      channel_id: channelId,
      channel_type: channelName,
    };

    try {
      const payload = {
        channel_config_id: channelConfigId,
        channelConfigName: channelConfigName,
        channelStatus: channelConfigStatus,
        channelConfig: JSON.stringify(wrapped),
        channelserver_url: selectedUrl,
        channelserver_Id: selectedChannelServerId,
        channelserver_app_Id: selectedChannelServerAppId,
        channel_Id: channelId,
        channelserver_app_Status: "inactive",
        accountId: accountId,
        partnerId: partnerId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      const response = await axios.delete(
        `${OperatorUrl}/DeleteChannelConfig`,
        {
          data: payload, // send as request body
        },
      );
      const data = response.data; // parsed JSON

      if (data.status === "Failure" || data.status === "Warning") {
        setIsDeleteDialogOpen(false);
        setIsUpdate(false);
        setCustomConfigText("");
        toast.toast({
          title: "Warning",
          description: data.status_Description || "Failed to delete",
        });
      } else {
        setIsConnectDialogOpen(false);
        setIsDeleteDialogOpen(false);
        setIsUpdate(false);
        setCustomConfigText("");
        toast.toast({
          title: "Success",
          description: data.status_Description || "Deleted successfully",
          variant: "default",
        });
        setIsConnectDialogOpen(false);
        setIsDeleteDialogOpen(false);

        fetchChannelConfigs(partnerId); // refresh the list
      }
    } finally {
      setIsApiExecuting(false);
      setIsDeleteDialogOpen(false);
      setIsUpdate(false);
      setCustomConfigText("");
    }
  };

  useEffect(() => {
    if (!isAlertOpen) {
      const timeout = setTimeout(() => {
        document.body.style.pointerEvents = "";
      }, 300);

      return () => clearTimeout(timeout);
    } else {
      document.body.style.pointerEvents = "auto";
    }
  }, [isAlertOpen, isDeleteDialogOpen]);

  // ✅ Extracted fetch function
 const fetchChannelConfigs = async (partnerId: number) => {
  try {
    setIsRefreshing(true);
    const response = await axios.get(
      `${OperatorUrl}/GetChannelConfigsByPartnerId`,
        {
          params: {
            partnerId,
            channelId,
            page: currentPage,
            pageSize: rowsPerPage,
          },
        },
    );
    if (response.data.channelConfigs?.length > 0) {
      setTableData(response.data.channelConfigs);
      setTotalCount(response.data.total);
    } else {
      setTableData([]);
      setTotalCount(0);
    }
  } catch (err: any) {
    console.error("Error fetching configs:", err);
    setTableData([]);
    setTotalCount(0);
  } finally {
    setLoading(false);
    setIsRefreshing(false);
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);
  }
};


  const fetchChannelServerUrls = async () => {
    try {
      const response = await axios.get(
        `${OperatorUrl}/GetChannelServerDetailsByChannelId?channelId=${channelId}`,
      );

      const serverList = response.data.channelServerDetails;

      if (serverList && serverList.length > 0) {
        const urls = serverList.map((item: any) => ({
          url: `${item.channelserver_ip}:${item.channelserver_app_port}`,
          channelserver_id: item.channelserver_id,
          channelserver_app_id: item.channelserver_app_id,
          channelserver_name: item.channelserver_name,
        }));

        setChannelUrls(urls);
      } else {
        setChannelUrls([]); // No data found
      }
    } catch (err: any) {
      console.error("Error fetching configs:", err);
      // setError("Failed to fetch channel configs.");
    } finally {
      setLoading(false);
    }
  };

  //   const handleRefresh = async () => {
  //   try {
  //     const response = await axios.get("http://your-api-url.com/refresh"); // Replace with actual API
  //     console.log("Refreshed data:", response.data);
  //     // Optionally show success toast
  //   } catch (error) {
  //     console.error("Failed to refresh:", error);
  //   }
  // };

  const handleUpdateChannelServerUrl = async () => {
    if (!selectedUrl || currentChannelId === null) {
      toast.toast({
        title: "Missing Selection",
        description: "Please select a valid URL and configuration.",
      });
      return;
    }

    try {
      setIsUpdating(true);

      const response = await axios.post(
        `${OperatorUrl}/UpdateChannelServerUrl`,
        {
          channel_config_id: currentChannelId,
          channelserver_url: selectedUrl,
          channelserver_Id: selectedChannelServerId,
          channelserver_app_Id: selectedChannelServerAppId,
          channel_Id: channelId,
          channelserver_app_Status: "inactive",
          accountId: accountId,
          partnerId: partnerId,
          channelType: channelName,
          ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        },
      );

      const data = response.data;

      if (data.success === false) {
        toast.toast({
          title: "Update Failed",
          description:
            data.message ||
            "Something went wrong while updating the channel server.",
        });
      } else if (data.channelMaintenanceStatus === "offline") {
        toast.toast({
          title: "Success",
          description: data.message, // If using shadcn or want to style it differently
        });
      } else if (data.channelMaintenanceStatus === "exception") {
        toast.toast({
          title: "Success",
          description: data.message, // If using shadcn or want to style it differently
        });
        setIsConnectDialogOpen(false);
        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Success",
          description:
            data.message || "Channel server URL updated successfully.",
        });
        setIsConnectDialogOpen(false);
        fetchChannelConfigs(partnerId);
      }
    } catch (err: any) {
      console.error("Update failed", err);
      toast.toast({
        title: "Error",
        description:
          err?.response?.data?.message ||
          "Failed to update channel server URL.",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const getChannelConfigById = async (configId: number) => {
    debugger;
    setIsUpdate(true);
    setLoading(true);

    try {
      const response = await axios.get(
        `${OperatorUrl}/GetChannelConfigByConfigId`,
        { params: { configId } },
      );

      const details = response.data.channelConfigDetails;
      console.log(details);

      setConfigs(details);

      setChannelConfigId(details.channel_config_id);
      setChannelConfigName(details.channel_config_name);
      setChannelConfigStatus(details.channel_status);

      let config2 = JSON.parse(details.channel_config);
      setSelectedOption(config2.api_type);
      setCustomConfigText(JSON.stringify(config2.config, null, 2));
      setSelectedUrl(details.channelserver_url);

      if (config2?.api_type === "custom" && !isDeleteDialogOpen) {
        setIsCustomDialogOpen(true);
      } else if (config2?.api_type === "meta") {
        setIsConnectDialogOpen(true);
      }

      return details; // ✅ return so caller can use it
    } catch (err) {
      console.error("Failed to fetch config:", err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    debugger;
    try {
      const userConfig = JSON.parse(customConfigText); // flat object

      // Wrap into `config` object
      const wrapped = {
        config: {
          ...userConfig,
        },
        api_type: selectedOption,
        api_vendor: workspace,
        channel_id: channelId,
        channel_type: channelName,
        max_validity_hours: 24,
      };

      // 1. Get unique config name from backend
      const { data } = await axios.get(
        `${OperatorUrl}/GenerateChannelConfigName`,
        {
          params: {
            workspace: workspace,
            configType: selectedOption,
          },
        },
      );

      setChannelConfigName(data.channelConfigName);

      let configname = data.channelConfigName;

      // 2. Prepare payload for insert API
      const payload = {
        ChannelId: Number(channelId),
        ChannelConfigName: configname,
        ChannelConfig: JSON.stringify(wrapped),
        ChannelStatus: "active", // or dynamically get from UI if needed
        PartnerId: workspaceId,
        accountId: accountId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      // 3. Insert the config via backend API
      const insertResponse = await axios.post(
        `${OperatorUrl}/InsertChannelConfig`,
        payload,
      );

      if (insertResponse.status === 200) {
        toast.toast({
          title: "Success",
          description: "Channel config inserted successfully.",
        });

        console.log("✅ Insert response:", insertResponse.data);

        setCustomConfigText("");

        setIsCustomDialogOpen(false);

        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Insert Failed",
          description: "Unexpected response from server.",
        });
      }
    } catch (error: any) {
      console.error("❌ Submission error:", error);
      toast.toast({
        title: "Error",
        description:
          error?.response?.data?.error ||
          "Failed to submit configuration. Please check and try again.",
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);
  }, [isConnectDialogOpen, isDeleteDialogOpen, isWelcomeTemplateDialogOpen]);

  const handleUpdate = async () => {
    try {
      const userConfig = JSON.parse(customConfigText); // flat object

      // Wrap into `config` object
      const wrapped = {
        config: {
          ...userConfig,
        },
        api_type: selectedOption,
        api_vendor: workspace,
        channel_id: channelId,
        channel_type: channelName,
      };

      debugger;
      // 2. Prepare payload for insert API
      const payload = {
        channel_config_id: channelConfigId,
        channelConfigName: channelConfigName,
        channelStatus: channelConfigStatus,
        channelConfig: JSON.stringify(wrapped),
        channelserver_url: selectedUrl,
        channelserver_Id: selectedChannelServerId,
        channelserver_app_Id: selectedChannelServerAppId,
        channel_Id: channelId,
        channelserver_app_Status: "inactive",
        partnerId: partnerId,
        accountId: accountId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      // 3. Insert the config via backend API
      const updateResponse = await axios.put(
        `${OperatorUrl}/UpdateChannelConfig`,
        payload,
      );

      const { status, status_Description } = updateResponse.data;

      if (
        status === "Failure" ||
        (status === "Warning" &&
          status_Description?.includes("is already in use"))
      ) {
        setIsCustomDialogOpen(false);
        setCustomConfigText("");
        setIsUpdate(false);
        toast.toast({
          title: "Warning",
          description: status_Description || "Failed to update",
          // or "warning" depending on your toast setup
        });
      } else {
        setIsCustomDialogOpen(false);
        setCustomConfigText("");
        setIsUpdate(false);
        toast.toast({
          title: "Success",
          description: status_Description || "Updated successfully",
          variant: "default",
        });
      }
    } catch (error: any) {
      console.error("Submission error:", error);
      setCustomConfigText("");
      setIsUpdate(false);
      toast.toast({
        title: "Error",
        description:
          error?.response?.data?.error ||
          "Failed to submit configuration. Please check and try again.",
      });
    }
  };
  const handleToggle = (itemId: number) => {
    setOpenMenuId((prev) => (prev === itemId ? null : itemId));
  };

  const handleStatusToggle = async (
    configId: number,
    currentStatus: string,
  ) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    try {
      const response = await axios.put(
        `${OperatorUrl}/UpdateChannelStatus`,
        null,
        {
          params: {
            configId: configId,
            newStatus: newStatus,
            accountId: accountId,
            partnerId: partnerId,
            channelType: channelName,
            ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
          },
        },
      );

      if (response.status === 200 && response.data) {
        toast.toast({
          title: "Status Updated",
          description: `Configuration status changed to ${newStatus}`,
        });

        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Update Failed",
          description: "Unexpected response from the server.",
        });
      }
    } catch (error: any) {
      console.error("Error updating channel status:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update channel status.";

      toast.toast({
        title: "Error",
        description: errorMessage,
      });
    } finally {
      setOpenMenuId(null);
    }
  };

  const handleConnectChannel = () => {
    console.log("Connecting channel server for:", openMenuId);
    setOpenMenuId(null);
  };

// ✅ Pass currentPage and rowsPerPage explicitly
useEffect(() => {
  fetchChannelConfigs(partnerId); // 👈 pass explicitly
  // eslint-disable-next-line
}, [partnerId, currentPage, rowsPerPage]);

  const fetchWelcomeTemplates = async (
    channelConfigId: number,
    channelId: number, // 👈 this is channelType logically
  ) => {
    debugger;
    try {
      debugger;
      console.log(channelConfigId);
      const response = await axios.get(
        `${OperatorUrl}/GetTemplatesByPartnerAndChannel`,
        {
          params: {
            channelConfigId: channelConfigId,
            channelType: channelId, // 👈 explicit mapping
          },
        },
      );
      debugger;
      if (response.data.status === "Success") {
        setWelcomeTemplateList(response.data.data || []);
        console.log("welcometemplatelist", welcomeTemplateList);
      }
    } catch (error) {
      console.error("Error fetching welcome templates:", error);
    }
  };

  return (
    <>
      <>
        <Toaster />
        {loading && (
          <div className="flex flex-col items-center justify-center h-[500px]">
            <CircularProgress color="primary" />
          </div>
        )}
        <div className="fixed flex justify-end gap-4 mr-[26px] items-end right-[0px] top-[-12px] z-20 ">
          {/* <Button
              variant={"outline"}
              className="w-[100px] border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
              onClick={() => setIsAlertOpen(true)}
              // onClick={() => {
              //   dispatch(setCreateBreadCrumb(false));
              //   navigate("/navbar/campaignlist");
              // }}
            >
              Disconnect
            </Button> */}
          <Button
            className="w-auto"
            onClick={() => {
              // launchWhatsAppSignup("addPhoneNumber");
              // checkTokenValidity();
              setIsConnectOpen(true);
            }}
          >
            Add Phone Number
          </Button>
          <Button
            variant="default"
            className="w-auto  bg-[#479E98]"
            onClick={() => fetchChannelConfigs(partnerId)}
            disabled={isRefreshing}
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            {isRefreshing ? "Refreshing..." : "Refresh"}
          </Button>
        </div>

        {/* <Dialog open={isAlertOpen} onOpenChange={setIsAlertOpen}>
          <DialogContent className="w-[300px]">
            <DialogHeader>
              <DialogTitle className="text-18px font-semibold text-[#09090B] mb-2">
                Disconnect WhatsApp Account
              </DialogTitle>
              <DialogDescription className="text-14px font-medium text-[#71717A]">
                Are you sure you want to disconnect this WhatsApp account?
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-end gap-4">
              <Button
                disabled={isApiExecuting}
                variant="outline"
                className="px-4 py-2 w-24"
                onClick={() => setIsAlertOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="px-4 py-2 w-24 bg-[#EF4444]"
                onClick={() => {
                  disconnectWhatsappAccount();
                  checkTokenValidity();
                }}
              >
                {isApiExecuting ? "Disconnecting..." : "OK"}
              </Button>
            </div>
          </DialogContent>
        </Dialog> */}

        <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
          <DialogContent className="w-full max-w-md">
            <DialogHeader>
              <DialogTitle>Confirm Delete</DialogTitle>
            </DialogHeader>

            <div>
              Are you sure you want to delete this channel configuration?
            </div>

            <DialogFooter className="mt-6 flex justify-end space-x-3">
              <Button
                variant="outline"
                className="w-24 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsDeleteDialogOpen(false)}
                //disabled={isApiExecuting}
              >
                Cancel
              </Button>

              <Button
                className="text-white w-24"
                onClick={handleDelete}
                //disabled={isApiExecuting}
              >
                OK
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog open={isConnectOpen} onOpenChange={setIsConnectOpen}>
          <DialogContent className="w-full max-w-xl">
            <DialogHeader>
              <DialogTitle>Connect WhatsApp Account</DialogTitle>
              <DialogDescription className="mb-4">
                Please choose how you want to connect your WhatsApp account.
              </DialogDescription>
            </DialogHeader>

            <RadioGroup
              value={selectedOption}
              onValueChange={setSelectedOption}
              className="space-y-3"
            >
              <div className="flex items-center space-x-2 cursor-pointer">
                <RadioGroupItem value="meta" id="meta" />
                <Label htmlFor="meta" className="cursor-pointer">
                  Meta WhatsApp
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="custom" id="custom" />
                <Label htmlFor="custom" className="cursor-pointer">
                  Custom WhatsApp
                </Label>
              </div>
            </RadioGroup>

            <DialogFooter className="mt-6">
              <Button
                variant="outline"
                className="w-24 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsConnectOpen(false)}
                disabled={isApiExecuting}
              >
                Cancel
              </Button>

              <Button
                className="text-white w-24"
                onClick={async () => {
                  if (selectedOption === "meta") {
                    setIsConnectOpen(false);
                    await new Promise((resolve) => setTimeout(resolve, 100)); // Allow dialog to close
                    launchWhatsAppSignup("connect");
                  } else if (selectedOption === "custom") {
                    setIsConnectOpen(false);
                    setIsCustomDialogOpen(true);
                  }
                }}
                disabled={isApiExecuting}
              >
                {"Next >"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog open={isCustomDialogOpen} onOpenChange={setIsCustomDialogOpen}>
          <DialogContent className="w-full max-w-xl">
            <DialogHeader>
              <DialogTitle>WhatsApp Info</DialogTitle>
              <DialogDescription>
                Paste your WhatsApp configuration below
              </DialogDescription>
            </DialogHeader>

            <textarea
              className="max-w-lg border rounded-md p-2"
              rows={6}
              placeholder=""
              value={customConfigText}
              onChange={(e) => setCustomConfigText(e.target.value)}
            />

            <DialogFooter className="mt-[-4]">
              <Button
                variant="outline"
                className="w-24 mt-0 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsCustomDialogOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="text-white w-24 m-0"
                onClick={isUpdate ? handleUpdate : handleSubmit}
              >
                {isUpdate ? "Update" : "Submit"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog
          open={isConnectDialogOpen}
          onOpenChange={setIsConnectDialogOpen}
        >
          <DialogContent className="w-full max-w-xl">
            <DialogHeader>
              <DialogTitle className="text-lg font-semibold text-[#09090B] mb-2">
                Connect to channel server
              </DialogTitle>
            </DialogHeader>

            <div className="w-full max-w-xl">
              <label className="mb-2 block text-sm font-medium">
                Select Server URL
              </label>
              <Select
                value={selectedUrl}
                onValueChange={(value) => {
                  setSelectedUrl(value);
                  const selected = channelUrls.find(
                    (item) => item.url === value,
                  );
                  if (selected) {
                    setSelectedChannelServerId(selected.channelserver_id);
                    setSelectedChannelServerAppId(
                      selected.channelserver_app_id,
                    );
                  }
                }}
              >
                <SelectTrigger className="w-full text-sm border-gray-300 hover:border-gray-400">
                  <SelectValue placeholder="Select URL" />
                </SelectTrigger>
                <SelectContent className="w-full border border-gray-200 shadow-lg">
                  {channelUrls.map((item, idx) => (
                    <SelectItem
                      key={idx}
                      value={item.url}
                      className="text-sm hover:bg-red-100 cursor-pointer"
                    >
                      {item.url} - ({item.channelserver_name})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex justify-end gap-4">
              <Button
                variant="outline"
                className="w-24  mt-0 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsConnectDialogOpen(false)}
              >
                Cancel
              </Button>
              <Button
                //disabled={isUpdating || !selectedUrl}
                className="w-24 m-0"
                onClick={async () => {
                  if (!selectedUrl || currentChannelId === null) return;
                  handleUpdateChannelServerUrl();
                  setIsConnectDialogOpen(false);
                  fetchChannelConfigs(partnerId);
                }}
              >
                {isUpdating ? "Saving..." : "Save"}
              </Button>
            </div>
          </DialogContent>
          {/* 
          <Dialog open={isWelcomeTemplateDialogOpen} onOpenChange={setIsWelcomeTemplateDialogOpen}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>
                  Link Welcome Template
                </DialogTitle>
              </DialogHeader>
              <div>
                <Label>Select Template</Label>

                <Select
                  value={selectedExtTemplateId}
                  onValueChange={(value) => setSelectedExtTemplateId(value)}
                >
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Select welcome template" />
                  </SelectTrigger>

                  <SelectContent>
                    {welcomeTemplateList.map((template) => (
                      <SelectItem
                        key={template.templateId}
                        value={template.extTemplateId}

                      >
                        {template.templateName}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>

              </div>

              <div>
  <Label>Select Template</Label>

  <Select
    value={selectedExtTemplateId}
    onValueChange={(value) => setSelectedExtTemplateId(value)}
    onOpenChange={(open) => !open && setWhatsappTemplateSearchQuery("")}
  >
    <SelectTrigger className="w-full">
      <SelectValue placeholder="Select welcome template" />
    </SelectTrigger>

    <SelectContent>
      <div className="flex items-center px-3 pb-2 border-b">
        <svg
          className="w-4 h-4 text-gray-400 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          type="text"
          placeholder="Search..."
          value={whatsappTemplateSearchQuery}
          onChange={(e) => setWhatsappTemplateSearchQuery(e.target.value)}
          className="flex-1 outline-none text-sm"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </div>
      <div className="max-h-[200px] overflow-y-auto">
        {welcomeTemplateList.length > 0 ? (
          welcomeTemplateList
            .filter(template =>
              template.templateName.toLowerCase().includes(whatsappTemplateSearchQuery.toLowerCase())
            )
            .map((template) => (
              <SelectItem
                key={template.templateId}
                value={template.extTemplateId}
              >
                {template.templateName}
              </SelectItem>
            ))
        ) : (
          <div className="px-3 py-2 text-sm text-gray-500">
            No templates available
          </div>
        )}
      </div>
    </SelectContent>
  </Select>
</div>

              <DialogFooter className="mt-6">
                <Button
                  variant="outline"
                  className="w-24"
                  onClick={() => setIsWelcomeTemplateDialogOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="w-24"
                  disabled={isUpdating || !selectedChannelConfigId}
                  onClick={() => updateWelcomeTemplate(Number(selectedExtTemplateId), selectedChannelConfigId)}
                >
                  {isUpdating ? "Linking..." : "Link"}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog> */}

          <Dialog
            open={isDeliveryWindowDialogOpen}
            onOpenChange={setIsDeliveryWindowDialogOpen}
          >
            <DialogContent className="w-full max-w-md">
              <DialogHeader>
                <DialogTitle className="text-lg font-semibold text-[#09090B]">
                  Message Validity Period
                </DialogTitle>
                <DialogDescription className="text-sm text-muted-foreground">
                  Set the campaign expiry time below.
                </DialogDescription>
              </DialogHeader>

              <div className=" space-y-6">
                {/* Input + Select Row */}
                <div className="flex items-center gap-4">
                  <Input
                    type="number"
                    value={ttlValue}
                    placeholder={unit === "hours" ? "Min 12" : "Max 30"}
                    className="w-36 h-10"
                    onChange={(e) => handleTTLChange(e.target.value)}
                    onBlur={handleTTLBlur} // 👈 add this
                  />

                  <Select
                    value={unit}
                    onValueChange={(val) => {
                      setUnit(val as "hours" | "days");
                      setTtlValue("");
                    }}
                  >
                    <SelectTrigger className="w-[130px] h-10">
                      <SelectValue placeholder="Unit" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="hours">Hours</SelectItem>
                      <SelectItem value="days">Days</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                {/* Hint Text */}
                <p className="text-xs text-muted-foreground">
                  {unit === "hours" && (
                    <>
                      Minimum <b>12 hours</b> · Maximum <b>720 hours</b> (30
                      days)
                    </>
                  )}
                  {unit === "days" && (
                    <>
                      Minimum <b>1 day</b> · Maximum <b>30 days</b>
                    </>
                  )}
                </p>
              </div>

              <DialogFooter className="flex justify-end gap-3 pt-2 ">
                <Button
                  variant="outline"
                  className="w-24 hover:bg-red-500 hover:text-white border-red-500 text-red-500 mt-4"
                  onClick={() => {
                    setIsDeliveryWindowDialogOpen(false);
                    setTtlValue("");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  disabled={
                    isUpdating ||
                    !ttlValue ||
                    (unit === "hours" &&
                      (Number(ttlValue) < 12 || Number(ttlValue) > 720)) ||
                    (unit === "days" &&
                      (Number(ttlValue) < 1 || Number(ttlValue) > 30))
                  }
                  className="w-24 mt-4"
                  onClick={() => {
                    updateDeliveryWindow(
                      Number(ttlValue),
                      unit,
                      selectedChannelConfigId,
                    );
                    setIsDeliveryWindowDialogOpen(false);
                  }}
                >
                  {isUpdating ? "Updating..." : "Update"}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </Dialog>
        {!loading && (
          <>
            <div className="rounded-md border mt-2">
              <div className="max-h-[60vh] overflow-y-auto">
                <Table
                  className="rounded-xl whitespace-nowrap border-gray-200  "
                  style={{ color: "#020202", fontSize: "15px" }}
                >
                  <TableHeader className="text-center text-[14px] font-medium">
                    <TableRow>
                      <TableHead className="">
                        <div className="flex items-center gap-6 justify-start cursor-pointer">
                          <input
                            type="checkbox"
                            // className={`text-muted-foreground ${
                            //   isAllSelected ? "accent-gray-700 bg-grey-700 text-red-500" : ""
                            // }`}
                            // checked={isAllSelected}
                            // onChange={handleSelectAll}
                          />
                        </div>
                      </TableHead>

                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start">
                          Channel Name{" "}
                          <CaretSortIcon
                          // onClick={() => sortCampaignList("ByCampaignChannel")}
                          // className="cursor-pointer"
                          />
                        </div>
                      </TableHead>
                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start">
                          Type{" "}
                          <CaretSortIcon
                          // onClick={() => sortCampaignList("ByCampaignStatus")}
                          // className="cursor-pointer"
                          />
                        </div>
                      </TableHead>
                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start">
                          Config Status{" "}
                          <CaretSortIcon
                          // onClick={() => sortCampaignList("ByCampaignDate")}
                          // className="cursor-pointer"
                          />
                        </div>
                      </TableHead>
                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start">
                          Channel Server Url{" "}
                          <CaretSortIcon
                          // onClick={() => sortCampaignList("ByCampaignStatus")}
                          // className="cursor-pointer"
                          />
                        </div>
                      </TableHead>
                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start">
                          Channel App Status{" "}
                          <CaretSortIcon
                          // onClick={() => sortCampaignList("ByCampaignDate")}
                          // className="cursor-pointer"
                          />
                        </div>
                      </TableHead>
                      {/* <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start">
                          Welcome Template{" "}
                          <CaretSortIcon
                          // onClick={() => sortCampaignList("ByCampaignDate")}
                          // className="cursor-pointer"
                          />
                        </div>
                      </TableHead> */}
                      <TableHead className="text-left"></TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody className="text-left text-[14px] font-normal">
                    {tableData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={7} className="text-center py-4">
                          No channel configurations found.
                        </TableCell>
                      </TableRow>
                    ) : (
                      tableData.map((data: any, index) => (
                        <>
                          <TableRow key={data.channel_config_id}>
                            <TableCell className="py-4 text-left">
                              <input
                                type="checkbox"
                                className="accent-gray-700 bg-grey-700"
                                // Add a state and handler if you want to manage checkbox selection
                              />
                            </TableCell>
                            <TableCell className="py-4 text-left">
                              {data.channel_config_name}
                            </TableCell>
                            <TableCell className="py-4 text-left">
                              {data.api_type}
                            </TableCell>
                            <TableCell className="py-4 text-left">
                              <Badge
                                className={`w-fit inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium
      ${
        data.channel_status?.toLowerCase() === "active"
          ? "bg-green-100 text-green-700 border border-green-300 hover:bg-green-100"
          : "bg-red-100 text-red-700 border border-red-300 hover:bg-red-100"
      }`}
                              >
                                <span className="flex items-center gap-1">
                                  <span
                                    className={`w-2 h-2 rounded-full ${
                                      data.channel_status?.toLowerCase() ===
                                      "active"
                                        ? "bg-green-500"
                                        : "bg-red-500"
                                    }`}
                                  />
                                  {data.channel_status}
                                </span>
                              </Badge>
                            </TableCell>
                            <TableCell className="py-4 text-left">
                              {data.channelserver_url}
                            </TableCell>
                            <TableCell className="py-4 text-left">
                              {["active", "inactive"].includes(
                                data.channelserver_app_status?.toLowerCase(),
                              ) ? (
                                <Badge
                                  onClick={() =>
                                    setOpenRow(openRow === index ? null : index)
                                  }
                                  className={`cursor-pointer w-fit inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium
        ${
          data.channelserver_app_status?.toLowerCase() === "active"
            ? "bg-green-100 text-green-700 border border-green-300 hover:bg-green-100"
            : "bg-red-100 text-red-700 border border-red-300 hover:bg-red-100"
        }`}
                                >
                                  {data.channelserver_app_status?.toLowerCase() ===
                                  "active" ? (
                                    <span className="w-2 h-2 rounded-full bg-green-500" />
                                  ) : (
                                    <Info className="w-3 h-3 text-red-500" />
                                  )}

                                  {data.channelserver_app_status}
                                </Badge>
                              ) : (
                                <span className="text-sm ml-2 text-gray-700 capitalize">
                                  {data.channelserver_app_status || "-"}
                                </span>
                              )}
                            </TableCell>
                            {/* <TableCell className="py-4 text-left">
                            {data.wm_template_id ? (
                              <div className="relative group inline-flex items-center gap-2 cursor-pointer">
                                <CheckCircle className="text-green-500 h-4 w-4" />
                                <span>Linked</span>

                                {data.template_name && (
                                  <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block
                        bg-gray-900 text-white text-xs rounded
                        px-2 py-1 whitespace-nowrap z-20">
                                    {data.template_name}
                                    <div className="absolute top-full left-3 w-0 h-0
                          border-l-4 border-r-4 border-t-4
                          border-transparent border-t-gray-900" />
                                  </div>
                                )}
                              </div>
                            ) : (
                              <span className="text-gray-400">-</span>
                            )}
                          </TableCell> */}

                            <TableCell></TableCell>
                            <TableCell>
                              <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <DotsHorizontalIcon className="cursor-pointer w-6 h-6" />
                                </DropdownMenuTrigger>
                                <DropdownMenuContent
                                  className="w-52 translate-x-4 rounded-lg shadow-md border border-gray-200 cursor-pointer"
                                  align="end"
                                >
                                  <DropdownMenuItem
                                    className="cursor-pointer"
                                    onClick={() =>
                                      handleStatusToggle(
                                        data.channel_config_id,
                                        data.channel_status,
                                      )
                                    }
                                  >
                                    {data.channel_status === "active"
                                      ? "Set as Inactive"
                                      : "Set as Active"}
                                  </DropdownMenuItem>
                                  <DropdownMenuItem
                                    className="cursor-pointer"
                                    onClick={() => {
                                      fetchChannelServerUrls();
                                      setCurrentChannelId(
                                        data.channel_config_id,
                                      );
                                      setIsConnectDialogOpen(true);
                                    }}
                                  >
                                    Connect to channel server
                                  </DropdownMenuItem>

                                  {data.api_type === "custom" && (
                                    <DropdownMenuItem
                                      className="cursor-pointer"
                                      onClick={() =>
                                        getChannelConfigById(
                                          data.channel_config_id,
                                        )
                                      }
                                    >
                                      Edit
                                    </DropdownMenuItem>
                                  )}

                                  <DropdownMenuItem
                                    className="cursor-pointer"
                                    onClick={() =>
                                      openDeleteDialog(
                                        data.channel_config_id,
                                        data.channel_config_name,
                                      )
                                    }
                                  >
                                    Delete
                                  </DropdownMenuItem>
                                  <DropdownMenuItem
                                    className="cursor-pointer"
                                    onClick={async () => {
                                      setSelectedChannelConfigId(
                                        data.channel_config_id,
                                      );

                                      await getTTLHours(data.channel_config_id);

                                      setIsDeliveryWindowDialogOpen(true);
                                    }}
                                  >
                                    {data.wm_template_id
                                      ? "Edit Message Validity Period"
                                      : "Message Validity Period"}
                                  </DropdownMenuItem>
                                </DropdownMenuContent>
                              </DropdownMenu>
                            </TableCell>
                          </TableRow>
                          {/* ✅ Expand Row */}
                          {openRow === index &&
                            data.channelserver_app_status?.toLowerCase() ===
                              "inactive" && (
                              <TableRow>
                                <TableCell colSpan={8} className="p-0">
                                  <div className="flex items-start gap-3 bg-red-50 border-t border-red-200 px-4 py-3">
                                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-red-100 text-red-600">
                                      !
                                    </div>

                                    <div className="text-sm">
                                      <div className="font-medium mt-1 text-red-700">
                                        {data.channelserver_app_remarks ||
                                          "Error occurred"}
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                        </>
                      ))
                    )}
                  </TableBody>
                </Table>
              </div>
            </div>
            {/* Pagination Section */}
            {/* Pagination Section */}
            <div className="flex justify-between items-center mt-4 px-4 pb-4">
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <span>
                  {totalCount === 0
                    ? "0 of 0 row(s) selected"
                    : `${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
                        currentPage * rowsPerPage,
                        totalCount,
                      )} of ${totalCount} row(s) selected`}
                </span>
              </div>
              <div className="flex items-center space-x-4 font-medium text-sm">
                <span className="text-[#020617] font-medium text-[14px]">
                  Rows per page
                </span>
                <div className="relative inline-block ml-2">
                  <select
                    disabled={totalCount === 0}
                    className={`cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                      totalCount === 0 ? "cursor-not-allowed bg-gray-100" : ""
                    }`}
                    style={{
                      width: "60px",
                      height: "30px",
                      textAlign: "left",
                      fontSize: "12px",
                      fontWeight: "400",
                      borderColor: "#E5E7EB",
                      boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
                    }}
                    value={rowsPerPage}
                    onChange={(e) => {
                      setRowsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {[5, 10, 20].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                  <CaretSortIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4" />
                </div>
                <div className="ml-4 mr-4">
                  <span className="text-[#020617] text-[14px] font-medium">{`Page ${currentPage} of ${totalPages || 1}`}</span>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    disabled={currentPage === 1 || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === 1 || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    «
                  </button>
                  <button
                    disabled={currentPage === 1 || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === 1 || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    ‹
                  </button>
                  <button
                    disabled={currentPage === totalPages || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === totalPages || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    ›
                  </button>
                  <button
                    disabled={currentPage === totalPages || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === totalPages || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    »
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </>
  );
};

export default Whatsapp;
